module.exports = __webpack_public_path__ + "img/Teaching-Research Case - Blue.60b510af.png";